import { FormElementConfig, FormGeneratorConfig } from '../../../utils/formGenerator'
import {
    FbCheckboxFormElement,
    FbSelectFormElement,
    FbSliderFormElement,
    FbTextFieldFormElement
} from '../../../utils/formElements'
import {
    CustomerGroupFormElement,
    PickZoneSelectFormElement,
} from '../../Optimization/StorageLocationOptimization/StorageLocationOptimization'

export const EditStorageFormConfigInitialValues = {
    name: 'Loading...',
    pickzone: '',
    pickzoneDistance: '',
    customerGroups: [],
    bestPosition: '',
    isFlowRack: false,
}

export const EditStorageFormConfig: FormGeneratorConfig = {
    name: {
        component: FbTextFieldFormElement,
        childProps: {
            label: 'Zone Name',
            disabled: true,
        },
    },
    pickzone: {
        component: PickZoneSelectFormElement,
        childProps: {
            label: 'Next pickzone',
        },
    },
    zoneEffFactor: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Zone efficiency factor',
            marks: true,
            step: 0.1,
            showValueLabel: 'on',
            key: 'zone_eff_factor',
            min: 1,
            max: 20,
        },
    },
    pickzoneDistance: {
        component: FbTextFieldFormElement,
        childProps: {
            label: 'Pickzone distance (m)',
            type: 'number',
        },
    },
    customerGroups: {
        component: CustomerGroupFormElement,
        childProps: {
            label: 'Picking groups',
            multiple: true,
        },
    },
    bestPosition: {
        component: FbTextFieldFormElement,
        childProps: {
            label: 'Best position',
        },
    },
    isFlowRack: {
        component: FbCheckboxFormElement,
        childProps: {
            label: 'Is flow Rack',
        },
    },
}

export const createAdditionalFormElement = (existingConfig: any) => (
    elementName: string,
    config: FormElementConfig
): FormGeneratorConfig => {
    // eslint-disable-next-line no-param-reassign
    existingConfig[elementName] = config
    //console.log(existingConfig)
    return existingConfig
}
